// ONB-001 (Macrofase A) — lo que una pantalla del registro le pasa a la siguiente, SOLO en la memoria de
// la página: nunca en localStorage, sessionStorage, cookies ni la URL.
//
// ONB-002: aquí ya no pasa ningún secreto. Lo que autentica entre pasos es la sesión corta de registro (una
// cookie httpOnly que pone el servidor). Esto solo evita volver a escribir el correo y dice qué mostrar.
export interface SignupHandoff {
  status: 'PENDING_EMAIL_VERIFICATION' | 'EMAIL_VERIFIED';
  email: string;
  /** Solo con PENDING_EMAIL_VERIFICATION: mostrar «Revisa tu correo» (viene del inicio de sesión). */
  showCheckEmail?: boolean;
  /** Solo con EMAIL_VERIFIED: se acaba de confirmar el correo con el enlace (la bienvenida lo dice). */
  justVerified?: boolean;
  /**
   * ONB-003, solo con EMAIL_VERIFIED: el correo ya se confirmó y este navegador no abrió el enlace; para
   * seguir aquí hay que abrir el enlace nuevo que se envió al correo (viene del inicio de sesión).
   */
  linkRequired?: boolean;
}

let current: SignupHandoff | null = null;

export const signupHandoff = {
  set(value: SignupHandoff): void { current = { ...value }; },
  peek(): SignupHandoff | null { return current; },
  clear(): void { current = null; },
};
